import { css } from '@emotion/react'

import Colors from '../theme/Colors'

export default function Placeholder(props: { wide?: boolean }) {
  return (
    <span
      css={css`
        display: inline-block;
        background: ${props.wide ? Colors.Gray50 : Colors.Gray200};
        border-radius: 2px;
        width: 100%;
        max-width: ${props.wide ? '300px' : '100px'};
        height: 8px;
      `}
      data-testid="placeholder"
    />
  )
}
